var map = {
	"./sticker_auora_balloon_lavender.png": 9146,
	"./sticker_auora_bear_face.png": 3254,
	"./sticker_auora_bow_pink.png": 6954,
	"./sticker_auora_cloud_iridescent.png": 3719,
	"./sticker_auora_clover_mint.png": 4419,
	"./sticker_auora_crown_gold.png": 9672,
	"./sticker_auora_flower_pink.png": 2789,
	"./sticker_auora_heart_pink.png": 6443,
	"./sticker_auora_house_pastel.png": 6933,
	"./sticker_auora_smiley_face.png": 7715,
	"./sticker_auora_sparkle_iridescent.png": 2759,
	"./sticker_auora_speech_auora_blue.png": 4109,
	"./sticker_auora_star_pastel.png": 6628,
	"./sticker_auora_streamer_pink.png": 9983
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1503;